"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8109,951],{

/***/ 20951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46066);




// TODO : <Carousels> ... </Carousels>
var Carousels = function(param) {
    var infinite = param.infinite, _slideShow = param.slideShow, slideShow = _slideShow === void 0 ? 1 : _slideShow, responsiveShow = param.responsiveShow, _autoPlay = param.autoPlay, autoPlay = _autoPlay === void 0 ? false : _autoPlay, _showDots = param.showDots, showDots = _showDots === void 0 ? false : _showDots, heading = param.heading, children = param.children;
    var settings = {
        dots: showDots,
        infinite: true,
        slidesToShow: slideShow,
        slidesToScroll: 1,
        autoplay: autoPlay,
        autoplaySpeed: 3000,
        speed: 800,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: slideShow,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: responsiveShow || 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: responsiveShow || 1,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: responsiveShow || 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "carousel-wrapper",
            children: [
                heading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "heading",
                    children: [
                        " ",
                        heading,
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_1__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    "aria-hidden": "true"
                }, settings), {
                    children: children
                }))
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Carousels);


/***/ }),

/***/ 18109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ section_nation_weekend; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/cards/card-v.js
var card_v = __webpack_require__(40166);
// EXTERNAL MODULE: ./src/components/carousels/index.js
var carousels = __webpack_require__(20951);
// EXTERNAL MODULE: ./src/components/image.js
var components_image = __webpack_require__(84334);
// EXTERNAL MODULE: ./src/utils/datalayer/send-datalayer.js
var send_datalayer = __webpack_require__(34892);
// EXTERNAL MODULE: ./src/utils/datasets/index.js
var datasets = __webpack_require__(34871);
// EXTERNAL MODULE: ./src/utils/helper.js
var helper = __webpack_require__(39334);
// EXTERNAL MODULE: ./src/utils/services.js
var services = __webpack_require__(73113);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(15072);
// EXTERNAL MODULE: ./src/constants/layout.js
var layout = __webpack_require__(38864);
;// CONCATENATED MODULE: ./src/components/sections/section-event/section-schneider/components/card-video-full.jsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  margin-bottom: 17px;\n\n  .resolution-image {\n    position: relative;\n    overflow: hidden;\n    background: #fefefe;\n    border-radius: 15px;\n\n    &::before {\n      display: block;\n      content: '';\n      padding-top: 56.25% !important;\n    }\n    .play-card-live {\n      z-index: 1;\n      position: absolute;\n      width: 0;\n      height: 0;\n      border-top: 20px solid transparent;\n      border-left: 40px solid rgba(255, 255, 255, 0.9);\n      border-bottom: 20px solid transparent;\n      transform: translate(-50%, -50%);\n      left: 50%;\n      top: 50%;\n      filter: drop-shadow(2px 2px 2px #000);\n    }\n\n    img,\n    iframe {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 0;\n      bottom: 0;\n      width: 100%;\n      height: 100%;\n    }\n    .detail-published {\n      position: absolute;\n      width: 100%;\n      z-index: 2px;\n      padding: 5px;\n      margin: 0px;\n      left: 0;\n      bottom: -3px;\n      font-size: 10px !important;\n      color: #ffffff !important;\n      background: rgba(27, 27, 27, 0.8);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




// import { IMAGE_DEFAULT } from 'constants/layout';
var CardVideoFull = function(param) {
    var data = param.data;
    if (lodash_default().isEmpty(data)) return;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
            className: "card-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "resolution-image",
                children: [
                    (data === null || data === void 0 ? void 0 : data.type_video) && (data === null || data === void 0 ? void 0 : data.video_src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "play-card-live"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (data === null || data === void 0 ? void 0 : data.image) || "".concat(layout/* IMAGE_DEFAULT */.TH),
                        width: "100%",
                        height: "100%",
                        alt: "card-wrapper",
                        title: (data === null || data === void 0 ? void 0 : data.title) || "image",
                        loading: "lazy"
                    })
                ]
            })
        })
    });
};
var CardWrapper = styled_components_browser_esm["default"].div(_templateObject());
/* harmony default export */ var card_video_full = (CardVideoFull);

;// CONCATENATED MODULE: ./src/components/sections/section-event/section-schneider/utils/index.jsx

function utils_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.resolution-dailymotion {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    padding-top: 52.25%;\n    &:before {\n      content: '';\n      /* background-color: #f1f1f1; */\n      border-radius: 10px;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n\n      padding-top: 52.25%;\n    }\n\n    .dailymotion-player-root {\n      background-color: #e4e4e4;\n      border-radius: 10px;\n      position: unset !important;\n      padding-bottom: unset !important;\n\n      .dailymotion-player-wrapper {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n      }\n    }\n    iframe {\n\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border-radius: 10px;\n    }\n  }\n\n  &.resolution-video {\n    & > div {\n      width: 100%;\n      height: 100%;\n      position: relative;\n      padding-top: 52.25%;\n      border-radius: 10px;\n    }\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border-radius: 10px;\n    }\n  }\n  &.resolution-image {\n    position: relative;\n    padding-top: 0;\n    overflow: hidden;\n  }\n"
    ]);
    utils_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var useVideoIframe = function(_data) {
    if (lodash_default().isEmpty(_data)) return null;
    switch(_data === null || _data === void 0 ? void 0 : _data.type_video){
        case "1":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResolutionWrapper, {
                    id: "dailymotion-".concat(_data === null || _data === void 0 ? void 0 : _data.video_src),
                    className: "resolution-dailymotion",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        src: "https://www.dailymotion.com/embed/video/".concat(_data === null || _data === void 0 ? void 0 : _data.video_src, "?autoplay=0"),
                        frameborder: "0"
                    })
                })
            });
        case "2":
        case "3":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResolutionWrapper, {
                className: "resolution-video",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                    width: "100%",
                    height: "100%",
                    loop: true,
                    playing: false,
                    muted: true,
                    url: "".concat(_data === null || _data === void 0 ? void 0 : _data.video_src)
                })
            });
        case "4":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResolutionWrapper, {
                className: "resolution-video",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: _data === null || _data === void 0 ? void 0 : _data.video_src
                    }
                })
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResolutionWrapper, {
                className: "resolution-video",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_video_full, {
                    data: _data
                })
            });
    }
};
var ResolutionWrapper = styled_components_browser_esm["default"].div(utils_templateObject());
/* harmony default export */ var utils = (useVideoIframe);

// EXTERNAL MODULE: ./src/utils/ads/dynamic-ads.js
var dynamic_ads = __webpack_require__(84920);
// EXTERNAL MODULE: ./src/utils/devices.js
var devices = __webpack_require__(97348);
;// CONCATENATED MODULE: ./src/components/sections/section-event/section-nation-weekend.js



function section_nation_weekend_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ads-election-flex {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n"
    ]);
    section_nation_weekend_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n  background-image: url(",
        ");\n  margin-bottom: 20px;\n  .iframe-election {\n    background-color: unset;\n    padding-bottom: 20px;\n  }\n  .section-iframe-election {\n    height: 892px;\n    border: unset;\n    @media (max-width: 690px) {\n      height: 910px;\n    }\n  }\n  .section-1 {\n    padding: 60px 0 30px 0;\n    @media (max-width: 690px) {\n      padding: 40px 0 30px 0;\n    }\n    .carousel-wrapper {\n      display: block;\n      margin: 0;\n      .slick-dots {\n        position: static;\n        /* padding-top: 15px; */\n\n        .slick-active {\n          button:before {\n            color: rgba(200, 200, 200) !important;\n          }\n        }\n        li {\n          width: 18px;\n          height: 18px;\n          button {\n            &:before {\n              content: '';\n              border-radius: 50%;\n              background-color: #fff;\n              width: 12px;\n              height: 12px;\n            }\n          }\n        }\n      }\n    }\n    .content {\n      display: flex;\n      gap: 20px;\n      .video-list {\n        text-align: start;\n        width: 67%;\n        position: relative;\n        @media (max-width: 768px) {\n          width: 100%;\n        }\n      }\n      .video-item-right {\n        width: 33%;\n        @media (max-width: 768px) {\n          display: none;\n        }\n        .item-video {\n          &:nth-of-type(1) {\n            margin-bottom: 24px;\n          }\n        }\n      }\n    }\n  }\n  .header {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    border-bottom: 2px solid #fff;\n    margin-bottom: 8px;\n    padding-bottom: 6px;\n    h2 {\n      font-size: 36px;\n      color: #fff;\n      font-weight: 400;\n      @media (max-width: 690px) {\n        font-size: 30px;\n      }\n    }\n    span {\n      color: #fff;\n      font-weight: 300;\n    }\n  }\n  .section-2 {\n    padding-bottom: 20px;\n    .content {\n      display: flex;\n      align-items: start;\n      gap: 20px;\n      .card-left {\n        width: 53%;\n        @media (max-width: 1024px) {\n          width: 59%;\n        }\n        @media (max-width: 690px) {\n          display: none;\n        }\n        .card-v {\n          min-height: 0;\n          margin-bottom: 0;\n          .card-v-thumb {\n            margin-bottom: 0;\n            border-radius: 0;\n            img {\n              border-radius: 0;\n            }\n          }\n          .card-v-content {\n            background-color: #fff;\n            padding: 10px 10px 0 10px;\n            .card-v-content-title {\n              font-size: 28px;\n              margin: 0;\n              @media (max-width: 1024px) {\n                font-size: 20px;\n              }\n            }\n            .card-v-content-meta {\n              margin-top: 20px;\n              justify-content: end;\n              padding: 0 10px 4px 0;\n              span,\n              svg {\n                font-size: 14px;\n              }\n            }\n          }\n        }\n      }\n      .card-list {\n        width: 50%;\n        display: flex;\n        flex-wrap: wrap;\n        gap: 10px;\n        @media (max-width: 690px) {\n          width: 100%;\n        }\n        .card-item {\n          width: calc(50% - 5px);\n          &:nth-of-type(1) {\n            display: none;\n          }\n          @media (max-width: 690px) {\n            &:nth-of-type(1) {\n              display: block;\n            }\n            &:nth-of-type(5) {\n              display: none;\n            }\n          }\n          .card-v-thumb {\n            margin-bottom: 0;\n            border-radius: 0;\n            img {\n              border-radius: 0;\n            }\n          }\n          .card-v {\n            margin-bottom: 0;\n            min-height: 0;\n            .card-v-content {\n              background-color: #fff;\n              padding: 10px;\n              .card-v-content-title {\n                margin: 0;\n                line-height: 1.5;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .section-3 {\n    padding-bottom: 40px;\n    .header {\n      width: 100%;\n      @media (max-width: 690px) {\n        width: 100%;\n      }\n    }\n    .content {\n      display: flex;\n      justify-content: space-between;\n      .card-list {\n        width: 100%;\n        display: flex;\n        gap: 10px;\n        @media (max-width: 690px) {\n          flex-wrap: wrap;\n        }\n        .card-item {\n          width: 25%;\n          @media (max-width: 1024px) {\n            width: 33.33%;\n            &:nth-of-type(4) {\n              display: none;\n            }\n          }\n          @media (max-width: 690px) {\n            width: calc(50% - 5px);\n            &:nth-of-type(4) {\n              display: block;\n            }\n          }\n          .card-v-thumb {\n            margin-bottom: 0;\n            border-radius: 0;\n            img {\n              border-radius: 0;\n            }\n          }\n          .card-v {\n            margin-bottom: 0;\n            min-height: 0;\n            .card-v-content {\n              background-color: #fff;\n              padding: 10px;\n              .card-v-content-title {\n                margin: 0;\n                line-height: 1.5;\n              }\n            }\n          }\n        }\n      }\n      .image-right {\n        display: none;\n        width: 20%;\n        @media (max-width: 690px) {\n          display: none;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

















var DynamicAds = dynamic_default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84920)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84920)
            ];
        }
    }
});
function SectionNationWeekEnd(param) {
    var ads = param.ads, data = param.data;
    if (lodash_default().isEmpty(data)) return null;
    var responsive = (0,devices/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var allData = {
        item1: (0,datasets/* convertDatasets */.b$)(data === null || data === void 0 ? void 0 : data.dataSet, "background", true),
        item2: (0,datasets/* convertDatasets */.b$)(data === null || data === void 0 ? void 0 : data.dataSet, "tag-video-section1", true),
        item3: (0,datasets/* convertDatasets */.b$)(data === null || data === void 0 ? void 0 : data.dataSet, "tag-section2", true),
        item4: (0,datasets/* convertDatasets */.b$)(data === null || data === void 0 ? void 0 : data.dataSet, "tag-section3", true),
        item5: (0,datasets/* convertDatasets */.b$)(data === null || data === void 0 ? void 0 : data.dataSet, "image-section3", true)
    };
    var ref = (0,react.useState)(), resDataSection1 = ref[0], setResDataSection1 = ref[1];
    var ref1 = (0,react.useState)(), resDataSection2 = ref1[0], setResDataSection2 = ref1[1];
    var ref2 = (0,react.useState)(), resDataSection3 = ref2[0], setResDataSection3 = ref2[1];
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var res, _tmp, _tmp1, _tmp2, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!!lodash_default().isEmpty(allData)) return [
                            3,
                            2
                        ];
                        _tmp = {};
                        _tmp1 = {};
                        _tmp2 = {};
                        return [
                            4,
                            Promise.all([
                                (0,services/* GET */.H)("/api/search/video/tag".concat((0,helper/* convertObjPath */.lJ)((_tmp.name = allData.item2, _tmp)), "&limit=7"), false, true),
                                (0,services/* GET */.H)("/api/search/tag".concat((0,helper/* convertObjPath */.lJ)((_tmp1.name = allData.item3, _tmp1)), "&limit=10"), false, true),
                                (0,services/* GET */.H)("/api/search/tag".concat((0,helper/* convertObjPath */.lJ)((_tmp2.name = allData.item4, _tmp2)), "&limit=6"), false, true)
                            ])
                        ];
                    case 1:
                        res = _state.sent();
                        if (!lodash_default().isEmpty(res[0])) setResDataSection1(res[0]);
                        if (!lodash_default().isEmpty(res[1])) setResDataSection2(lodash_default().uniqBy(res[1].data, "id"));
                        if (!lodash_default().isEmpty(res[2])) setResDataSection3(lodash_default().uniqBy(res[2].data, "id"));
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        console.error("".concat((0,helper/* timestamp */.AB)(), " ==========> EVENT_ELECTION-2566 ERROR :"), err === null || err === void 0 ? void 0 : err.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWrapper, {
            className: "section-nation-weekend",
            bg: allData === null || allData === void 0 ? void 0 : allData.item1,
            style: {
                filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : "unset"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: !lodash_default().isEmpty(resDataSection1 === null || resDataSection1 === void 0 ? void 0 : resDataSection1.data) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "section-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "video-list",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousels["default"], {
                                        slideShow: 1,
                                        autoplay: true,
                                        responsiveShow: 1,
                                        infinite: true,
                                        showDots: true,
                                        children: lodash_default().map(resDataSection1 === null || resDataSection1 === void 0 ? void 0 : resDataSection1.data.slice(0, 5), function(el, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "item-video",
                                                children: utils(el)
                                            }, i);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "video-item-right",
                                    children: lodash_default().map(resDataSection1 === null || resDataSection1 === void 0 ? void 0 : resDataSection1.data.slice(5, 7), function(el, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "item-video",
                                            children: utils(el)
                                        }, i);
                                    })
                                })
                            ]
                        })
                    })
                }),
                !lodash_default().isEmpty(constants/* IFRAME_ELECTION */._r) && (router === null || router === void 0 ? void 0 : router.asPath) === "/category/politics" && /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    id: "section-iframe-election",
                    className: "section-iframe-election",
                    src: constants/* EMBED_ELECTION_ON_WEB */.hB || constants/* IFRAME_ELECTION */._r,
                    width: "100%"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        !lodash_default().isEmpty(constants/* IFRAME_ELECTION */._r) && (router === null || router === void 0 ? void 0 : router.asPath) === "/category/politics" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: responsive.isLaptopMini && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsElectionIframe, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "ads-election-flex",
                                                children: [
                                                    !lodash_default().isEmpty(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                        position: dynamic_ads.KEY_ADS_POSITION.ELECTION_1,
                                                        data: ads
                                                    }),
                                                    !lodash_default().isEmpty(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                        position: dynamic_ads.KEY_ADS_POSITION.ELECTION_2,
                                                        data: ads
                                                    }),
                                                    !lodash_default().isEmpty(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                        position: dynamic_ads.KEY_ADS_POSITION.ELECTION_3,
                                                        data: ads
                                                    }),
                                                    !lodash_default().isEmpty(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                        position: dynamic_ads.KEY_ADS_POSITION.ELECTION_4,
                                                        data: ads
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: responsive.isTabletMini && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ads-election-flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(carousels["default"], {
                                            slideShow: 1,
                                            autoplay: true,
                                            responsiveShow: 1,
                                            infinite: true,
                                            showDots: true,
                                            children: [
                                                !lodash_default().isEmpty(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                    position: dynamic_ads.KEY_ADS_POSITION.ELECTION_1,
                                                    data: ads
                                                }),
                                                !lodash_default().isEmpty(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                    position: dynamic_ads.KEY_ADS_POSITION.ELECTION_2,
                                                    data: ads
                                                }),
                                                !lodash_default().isEmpty(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                    position: dynamic_ads.KEY_ADS_POSITION.ELECTION_3,
                                                    data: ads
                                                }),
                                                !lodash_default().isEmpty(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                    position: dynamic_ads.KEY_ADS_POSITION.ELECTION_4,
                                                    data: ads
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        !lodash_default().isEmpty(resDataSection2) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "section-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: allData === null || allData === void 0 ? void 0 : allData.item3
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/tags/".concat(allData === null || allData === void 0 ? void 0 : allData.item3),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "ดูทั้งหมด"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "card-left",
                                            children: lodash_default().map(resDataSection2.slice(0, 1), function(el, i) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    className: "card-item",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_v["default"], {
                                                        data: el,
                                                        description: false,
                                                        badge: true,
                                                        path: el.link,
                                                        //! DATALAYER
                                                        eventDataLayer: {
                                                            type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                            router: router === null || router === void 0 ? void 0 : router.pathname,
                                                            section: "section-energy-time",
                                                            position: "ใต้: section-bitkub",
                                                            data: {
                                                                title: el === null || el === void 0 ? void 0 : el.title,
                                                                heading: "ข่าว-section-energy-time",
                                                                index: 1
                                                            }
                                                        }
                                                    })
                                                }, i);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "card-list",
                                            children: lodash_default().map(resDataSection2.slice(0, 5), function(el, i) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    className: "card-item",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_v["default"], {
                                                        data: el,
                                                        description: false,
                                                        showFooter: false,
                                                        badge: true,
                                                        path: el.link,
                                                        //! DATALAYER
                                                        eventDataLayer: {
                                                            type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                            router: router === null || router === void 0 ? void 0 : router.pathname,
                                                            section: "section-energy-time",
                                                            position: "ใต้: section-bitkub",
                                                            data: {
                                                                title: el === null || el === void 0 ? void 0 : el.title,
                                                                heading: "ข่าว-section-energy-time",
                                                                index: 1
                                                            }
                                                        }
                                                    })
                                                }, i);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        !lodash_default().isEmpty(resDataSection3) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "section-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: allData === null || allData === void 0 ? void 0 : allData.item4
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/tags/".concat(allData === null || allData === void 0 ? void 0 : allData.item4),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "ดูทั้งหมด"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "card-list",
                                            children: lodash_default().map(resDataSection3.slice(0, 4), function(el, i) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    className: "card-item",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_v["default"], {
                                                        data: el,
                                                        description: false,
                                                        showFooter: false,
                                                        badge: true,
                                                        path: el.link,
                                                        //! DATALAYER
                                                        eventDataLayer: {
                                                            type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                            router: router === null || router === void 0 ? void 0 : router.pathname,
                                                            section: "section-energy-time",
                                                            position: "ใต้: section-bitkub",
                                                            data: {
                                                                title: el === null || el === void 0 ? void 0 : el.title,
                                                                heading: "ข่าว-section-energy-time",
                                                                index: 1
                                                            }
                                                        }
                                                    })
                                                }, i);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "image-right",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image["default"], {
                                                image: allData.item5,
                                                external: true,
                                                title: "image",
                                                type: "CARD_MEDIUM"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var AdsElectionIframe = styled_components_browser_esm["default"].div(section_nation_weekend_templateObject());
var SectionWrapper = styled_components_browser_esm["default"].div(_templateObject1(), function(props) {
    return props.bg;
});
/* harmony default export */ var section_nation_weekend = (SectionNationWeekEnd);


/***/ }),

/***/ 34871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b$": function() { return /* binding */ convertDatasets; }
/* harmony export */ });
/* unused harmony exports ModifyMenu, convertDatasetsLists, convertDataLists, convertDataListsNonNullCount */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);




function convertDatasets(data, topic, isValue) {
    if (lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(data)) return null;
    var results = [];
    if (isValue) {
        for(var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i++){
            var ref, ref1;
            if (data === null || data === void 0 ? void 0 : (ref = data[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.key) === null || ref1 === void 0 ? void 0 : ref1.startsWith(topic)) {
                var ref2;
                results === null || results === void 0 ? void 0 : results.push(data === null || data === void 0 ? void 0 : (ref2 = data[i]) === null || ref2 === void 0 ? void 0 : ref2.value);
            }
        }
    } else {
        for(var i1 = 0; i1 < (data === null || data === void 0 ? void 0 : data.length); i1++){
            var ref3, ref4;
            if (data === null || data === void 0 ? void 0 : (ref3 = data[i1]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.topic) === null || ref4 === void 0 ? void 0 : ref4.startsWith(topic)) {
                var ref5;
                results === null || results === void 0 ? void 0 : results.push(data === null || data === void 0 ? void 0 : (ref5 = data[i1]) === null || ref5 === void 0 ? void 0 : ref5.dataSet);
            }
        }
    }
    return isValue ? results[0] : results;
}
function ModifyMenu(_array) {
    if (!Array.isArray(_array) || !_array) return [];
    return Array.isArray(_array) && _array.reduce(function(acc, cur) {
        var indexEl = _array.findIndex(function(el) {
            return el.nameEng.indexOf("lottery") && cur.nameEng.indexOf("lottery");
        });
        if (indexEl !== -1) {
            return _to_consumable_array(acc).concat([
                _object_spread({}, cur)
            ]);
        } else {
            return _to_consumable_array(acc).concat([
                _object_spread_props(_object_spread({}, cur), {
                    sub: []
                })
            ]);
        }
    }, []);
}
function convertDatasetsLists(data, topic) {
    var results = [];
    data.forEach(function(el) {
        var indexEl = topic.indexOf(el.key);
        if (indexEl !== -1) {
            return results.push(el.value);
        }
    }, []);
    return results;
}
function sortDataByKey(data) {
    return data.sort(function(a, b) {
        var ref, ref1;
        var numA = parseInt(((ref = a.key.match(/\d+$/)) === null || ref === void 0 ? void 0 : ref[0]) || 0, 10);
        var numB = parseInt(((ref1 = b.key.match(/\d+$/)) === null || ref1 === void 0 ? void 0 : ref1[0]) || 0, 10);
        return numA - numB;
    });
}
function convertDataLists(data, keys) {
    var result = {};
    var sortData = sortDataByKey(data);
    keys.forEach(function(key) {
        var keyData = sortData.filter(function(item) {
            return item.key.startsWith(key);
        });
        var values = keyData.map(function(item) {
            return item.value;
        });
        result[key.substring(0, key.length - 1)] = values;
    });
    return result;
}
function convertDataListsNonNullCount(data, keys) {
    var result = {};
    var sortData = sortDataByKey(data);
    keys.forEach(function(key) {
        var keyData = sortData.filter(function(item) {
            return item.key.startsWith(key);
        });
        var values = keyData.map(function(item) {
            return item.value;
        });
        var nonNullCount = values.filter(function(value) {
            return value !== null;
        }).length;
        result[key.substring(0, key.length - 1)] = {
            values: values,
            nonNullCount: nonNullCount
        };
    });
    return result;
}


/***/ }),

/***/ 97348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_1__);


var useResponsive = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isClient = ref[0], setIsClient = ref[1];
    var isMobile = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        maxWidth: "690px"
    });
    var isTabletMini = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        maxWidth: "767px"
    });
    var isLaptopMini = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        minWidth: "768px"
    });
    var isTablet = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        maxWidth: "900px"
    });
    var isLaptop = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        minWidth: "691px"
    });
    var isDesktop = (0,react_responsive__WEBPACK_IMPORTED_MODULE_1__.useMediaQuery)({
        minWidth: "1024px"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (true) setIsClient(true);
    }, []);
    return {
        isDesktop: isClient ? isDesktop : true,
        isLaptop: isClient ? isLaptop : true,
        isTablet: isClient ? isTablet : false,
        isMobile: isClient ? isMobile : false,
        isTabletMini: isClient ? isTabletMini : false,
        isLaptopMini: isClient ? isLaptopMini : false
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useResponsive);


/***/ })

}]);